<!--
 * @Author: Gaho
 * @Date: 2024-01-12 13:35:50
 * @LastEditors: Merlin
 * @LastEditTime: 2024-10-16 16:51:02
 * @Description: 目前仅用于 Waves 游戏 
-->

<template>
    <!--
        所有列： 
        押注 | 总押注 | 入场价格 | 爆仓价格 | 出场价格 | P&L, ROI | 状态 
    -->

    <!-- ↓ 押注（币种图标） -->
    <CasinoHistoryHeaderCell
        is-show-tablet
        is-show-mobile
        :text="$tFn('waves.Bet').toUpperCase()"
        class="flex-[0.3]"
    />
    <!-- ↓ 总押注 -->
    <CasinoHistoryHeaderCell
        class="flex-[0.4]"
        is-show-tablet
        is-show-mobile
        :text="$tFn('waves.calc_Wager').toUpperCase()"
    />
    <!-- ↓ 入场价格 -->
    <CasinoHistoryHeaderCell
        is-show-tablet
        :text="$tFn('waves.calc_EntryPrice').toUpperCase()"
        class="flex-[0.5]"
    />
    <!-- ↓ 爆仓价格，  -->
    <CasinoHistoryHeaderCell
        is-show-tablet
        :text="$tFn('waves.calc_BustPrice').toUpperCase()"
        class="flex-[0.5]"
    />
    <!-- ↓ 出场价格，仅 >=779 可见-->
    <CasinoHistoryHeaderCell
        :text="$tFn('waves.calc_ExitPrice').toUpperCase()"
        class="flex-[0.5]"
    />
    <!-- ↓ P&L, ROI -->
    <CasinoHistoryHeaderCell
        class="flex-[0.5]" 
        is-show-tablet
        is-show-mobile
        :text="$tFn('waves.calc_PL_ROI').toUpperCase()"
    />

    <CasinoHistoryHeaderCell
        class="flex-[0.6] pr-1" 
        is-show-tablet
        is-show-mobile
        :text="$tFn('waves.Status').toUpperCase()"
    />
</template>

<script setup lang="ts">
import useTranslation from '~/i18n/useTransLation';
import { HistoryTabsEnum } from '@/components/Casino/History/Tabs/ts/Tabs';

const {t: $tFn} = useNuxtApp().$i18n;
const tt = useTranslation();
const props = defineProps({
    isMobileMode: Boolean, // 声明出来，否则控制台一直打印 warn 信息 
    tabName: {
        type: String as PropType<HistoryTabsEnum>, 
    },
});


</script>
